import { fromEnum } from '../responseUtil';

export enum ApiMeansOfTransportType {
    TRUCK = 'truck',
    OWN_WHEELS = 'own-wheels',
    RORO_VESSEL = 'roro-vessel',
    CONTAINER_VESSEL = 'container-vessel',
    TRAIN = 'train',
}

export const MeansOfTransportTypeCodec = fromEnum<ApiMeansOfTransportType>(
    'ApiMeansOfTransportType',
    ApiMeansOfTransportType,
);
